import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { InvoiceBagProjectDataResponse, InvoiceBagResponse } from 'src/app/models/invoice.model';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { SalesService } from 'src/app/services/sales.service';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { DateUtil } from 'src/app/common/util';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';

@Component({
  selector: 'app-history-invoice-bag',
  templateUrl: './history-invoice-bag.component.html',
  styleUrls: ['./history-invoice-bag.component.scss']
})
export class HistoryInvoiceBagComponent implements OnInit {
  @ViewChildren('tooltip') tooltips: QueryList<TooltipDirective>;
  invoices: InvoiceBagProjectDataResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  search = "";

  deleting: { [key: string]: boolean } = {};
  reinvoicing: { [key: string]: boolean } = {};
  dataWarehouse: { [key: number]: WarehouseResponse } = {};
  downloading: { [key: number]: boolean } = {};
  downloadingInvoice: { [key: number]: boolean } = {};
  waitingFor = null;
  seeingAnulate = false;
  anulating = false;
  currentCompany = null;
  isAscendent = 1;
  startDate = "";
  endDate = "";
  gettingData = true;
  reinvoice = true;
  companyName = "";
  company = null;

  constructor(
    private invoiceService: InvoiceSaleService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private saleService: SalesService,
    private createService: TemplateInvoice,
    private authService: AuthenticationService
  ) {
    var today = new Date();
    this.endDate = today.toISOString().split("T")[0];
    today.setDate(1);
    this.startDate = today.toISOString().split("T")[0];
    this.companyName = JSON.parse(authService.getCurrentCompany()).companyName;
    this.company = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit(): void {
    this.warehouseService.getWarehouseByClue('').subscribe(
      {
        next: (response: ResponseObject) => {
          var warehouses: WarehouseResponse[] = response.data;
          warehouses.forEach((warehouse) => {
            if (warehouse.logo){
              warehouse.logo = "https://s3.amazonaws.com/rrhh-images/warehouse/logos/" + warehouse.logo;
            }
            this.dataWarehouse[warehouse.name] = warehouse;
          });
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las bodegas");
        }
      }
    );
    this.getInvoiceBag();
  }

  getInvoiceBag() {
    this.invoiceService.getInvoiceBag(DateUtil.parseDateToMilliseconds(this.startDate), DateUtil.parseDateToMilliseconds(this.endDate)).subscribe(
      {
        next: (response: ResponseObject) => {
          this.gettingData = false;
          if (response) {
            this.invoices = response.data;
            if (this.isAscendent == 1) {
              this.invoices.reverse();
            }
            this.pagination.total = response.data;
            this.resetPagination();
            this.searching();
          } else {
            this.toastService.success("Aún no existen facturas en la bolsa");
          }
        },
        error: (error: HttpErrorResponse) => {
          this.gettingData = false;
          this.toastService.error("Error al obtener la bolsa de facturas");
        }
      }
    );
  }

  changeOrder() {
    this.pagination.total.reverse();
    this.resetPagination();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    if (this.search == '') {
      this.pagination.total = this.invoices;
    } else {
      this.pagination.total = this.invoices.filter((invoice) => {
        return invoice.reciboNumero.toLowerCase().includes(this.search.toLowerCase()) || invoice.reciboSerie.toLowerCase().includes(this.search.toLowerCase())
          || invoice.factSerie.toLowerCase().includes(this.search.toLowerCase()) || invoice.factNumero.toLowerCase().includes(this.search.toLowerCase())
          || invoice.factWarehouse.toLowerCase().includes(this.search.toLowerCase()) || (invoice.reciboTotal + "") == this.search || (invoice.factTotal + "") == this.search;
      });
    }
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  confirmReinvoice(toDelete: InvoiceBagResponse) {
    if (this.reinvoicing[toDelete.id]) {
      return;
    }
    this.reinvoicing[toDelete.id] = true;
    this.invoiceService.removeClientBackendInvoice(toDelete.id).subscribe({
      next: () => {
        this.toastService.success("Se ha refacturado");
        this.reinvoicing = {};
        this.deleting = {};
        this.waitingFor = null;
        this.getInvoiceBag();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al refacturar");
      }
    });
  }

  confirmAnulate(toDelete: InvoiceBagResponse) {
    if (this.deleting[toDelete.id]) {
      return;
    }
    this.deleting[toDelete.id] = true;
    this.invoiceService.anulateClientBackendInvoice(toDelete.id).subscribe({
      next: () => {
        this.toastService.success("Se ha anulado la factura");
        this.reinvoicing = {};
        this.deleting = {};
        this.waitingFor = null;
        this.getInvoiceBag();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al anular la factura");
      }
    });
  }

  assignTo(toDelete: InvoiceBagResponse, reinvoice = true) {
    this.forceHideAllTooltips();
    if (this.waitingFor) {
      return;
    }
    this.reinvoice = reinvoice;
    this.waitingFor = toDelete;
  }

  forceHideAllTooltips() {
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => {
        if (tooltip.isOpen) {
          tooltip.hide();
        }
      });
    }
  }

  downloadReceipt(invoice: InvoiceBagProjectDataResponse) {
    if (this.downloading[invoice.id]) {
      return;
    }
    this.downloading[invoice.id] = true;
    var cloneInvoice = Object.assign({}, invoice) as InvoiceBagProjectDataResponse;
    this.saleService.getDetailBackendInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.downloading[invoice.id] = false;
        cloneInvoice.items = response.data;
        const template = this.createReceiptFromData(cloneInvoice) as InvoiceTemplateModel;
        this.createInvoicePDF(template);
      },
      error: (error: HttpErrorResponse) => {
        this.downloading[invoice.id] = false;
        this.toastService.error("Error obtener el recibo");
      }
    })
  }

  downloadInvoice(invoice: InvoiceBagProjectDataResponse) {
    if (this.downloadingInvoice[invoice.id]) {
      return;
    }
    this.downloadingInvoice[invoice.id] = true;
    this.saleService.getDetailSeries(invoice.factSerie, invoice.factNumero).subscribe({
      next: (response: ResponseObject) => {
        this.downloadingInvoice[invoice.id] = false;
        var cloneInvoice = Object.assign({}, response.data.clientInvoice);
        cloneInvoice.items = response.data.clientInvoiceDetailList;
        const template = this.createInvoiceFromData(cloneInvoice, invoice.factWarehouse) as InvoiceTemplateModel;
        this.createInvoicePDF(template);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
        this.downloadingInvoice[invoice.id] = false;
      }
    })
  }

  async createInvoicePDF(invoiceData: InvoiceTemplateModel) {
    var selected = invoiceData.warehouse as WarehouseResponse;
    var configurationInvoice = new ConfigurationInvoice(selected.nfact, selected.fcolor, selected.scolor, selected.tcolor, selected.slogan);
    if (selected.logo) {
      this.createService.selectTemplate(configurationInvoice, invoiceData, selected.logo);
    } else {
      if (this.currentCompany) {
        if (!this.currentCompany.companyLogo.includes("/images/company-avatar2.png")) {
          this.createService.selectTemplate(configurationInvoice, invoiceData, this.currentCompany.companyLogo);
        } else {
          this.createService.selectTemplate(configurationInvoice, invoiceData, null);
        }
      } else {
        this.createService.selectTemplate(configurationInvoice, invoiceData, null);
      }
    }
  }

  createReceiptFromData(invoiceData: InvoiceBagProjectDataResponse): InvoiceTemplateModel {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.warehouse = this.dataWarehouse[invoiceData.factWarehouse];
    templateGenerated.type = InvoiceType.BACKEND;
    templateGenerated.client.name = 'Consumidor final';
    templateGenerated.client.nit = 'CF';
    templateGenerated.client.address = "DIRECCION1";
    templateGenerated.certifier.signature = '';
    templateGenerated.certifier.date = "";
    templateGenerated.certifier.nit = "";
    templateGenerated.certifier.data = "";
    templateGenerated.invoice.date = (invoiceData.factDate) ? new Date(invoiceData.factDate).toLocaleDateString('en-CA') : "";
    templateGenerated.invoice.number = (invoiceData.reciboNumero) ? invoiceData.reciboNumero : "";
    templateGenerated.invoice.serial = (invoiceData.reciboSerie) ? invoiceData.reciboSerie : "";
    templateGenerated.seller.name = this.companyName;
    templateGenerated.seller.city = "";
    templateGenerated.seller.nit = templateGenerated.warehouse.nit ? templateGenerated.warehouse.nit : (this.company.companyNIT ? this.company.companyNIT : "");
    templateGenerated.seller.state = '';
    templateGenerated.seller.street = "";
    var totalTemp = 0;
    invoiceData.items.forEach(bd => {
      totalTemp += bd.quantity * bd.price;
      templateGenerated.items.push(new InvoiceItemModel(bd.quantity, bd.price, bd.descriptionProduct));
    });
    templateGenerated.total = totalTemp;
    return templateGenerated;
  }

  createInvoiceFromData(invoiceData: any, warehouse): InvoiceTemplateModel {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.warehouse = this.dataWarehouse[warehouse];
    console.log(this.dataWarehouse[warehouse]);
    templateGenerated.type = InvoiceType.NORMAL;
    templateGenerated.client.name = 'Consumidor final';
    templateGenerated.client.nit = 'CF';
    templateGenerated.client.address = "DIRECCION2";
    templateGenerated.certifier.signature = '';
    templateGenerated.certifier.date = "";
    templateGenerated.certifier.nit = "";
    templateGenerated.certifier.data = "";
    templateGenerated.invoice.date = (invoiceData.date) ? new Date(invoiceData.date).toLocaleDateString('en-CA') : "";
    templateGenerated.invoice.number = (invoiceData.number) ? invoiceData.number : "";
    templateGenerated.invoice.serial = (invoiceData.series) ? invoiceData.series : "";
    templateGenerated.seller.name = this.companyName;
    templateGenerated.seller.city = "";
    templateGenerated.seller.nit = this.dataWarehouse[warehouse].nit ? this.dataWarehouse[warehouse].nit : (this.company.companyNIT ? this.company.companyNIT : "");
    templateGenerated.seller.state = '';
    templateGenerated.seller.street = "";
    var totalTemp = 0;
    invoiceData.items.forEach(bd => {
      var price = bd.price + bd.taxes + (bd.extraTaxAmount ? bd.extraTaxAmount : 0);
      totalTemp += bd.quantity * price;
      templateGenerated.items.push(new InvoiceItemModel(bd.quantity, price, bd.descriptionProduct));
    });
    templateGenerated.total = invoiceData.totalCost + invoiceData.totalTaxes + (invoiceData.totalExtraTax ? invoiceData.totalExtraTax : 0);
    return templateGenerated;
  }
}
